
import Vue from 'vue';

import TicketReportEchartsLine from './components/echarts/TicketReportEchartsLine';
Vue.component(TicketReportEchartsLine.name, TicketReportEchartsLine);



// WEBPACK FOOTER //
// ./src/components-echarts.js